/**
 *
 * Asynchronously loads the component for Preferences
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
